module.exports = __webpack_public_path__ + "static/media/eject.70b4a558.svg";